const wifeEN = {
    chat: "<1>Talking to {{wife}}</1>" +
        "<2/>" +
        "You chatted with <3/> for an hour on various topics.\n\n" +
        "<4>Continue</4>",
    makeOut: "<1>Kissing with {{wife}}</1>" +
        "<2/>" +
        "<3>{{wife}}, there's something on your lip, let me see...</3>" +
        "You passionately kissed your wife.\n\n" +
        "<4>Continue</4>",
    busy: "<1>{{wife}}</1>" +
        "<2/>" +
        "<3>What do you want?</3>" +
        "<3>No, I'm busy now, leave me alone!</3> (Level up your relationships with <4/>)\n\n" +
        "<5>Get off</5>",
    howSheFeels: {
        part1: "<1>{{wife}}</1>" +
            "<2/>" +
            "<3>How are you? How are you feeling?</3>",
        part2: "<1>It's okay, I'm busy.</1>" +
            "Apparently she doesn't really want to talk to me. <2>Relationships > 22</2><3/><3/>" +
            "<4>Get off from {{wife}}</4>",
        part3: "<1>Well, not very well. I don’t know what’s wrong with me, but some kind of weak condition makes me feel nauseous.</1>" +
            "<2>Let me get you an aspirin then and get some sleep...</2>" +
            "<1>Yes, you're probably right, need to get some sleep.</1>" +
            "You brought <3/> an aspirin, then covered her with a blanket and she fell asleep.\n\n" +
            "<4>Go away</4>",
        part4: "<1>Perfect, why?</1>" +
            "<2>Nothing, just making sure everything is fine.</2><3/> looked at you with a blank look.\n\n" +
            "<4>Move away from {{wife}}</4>"
    },
    watchPorn: "<1>What? What a disgusting thing, I don’t even think ... What is it with me today ...</1>" +
        "<2>Not available in this version.</2><3/><3/>" +
        "<4>Move away</4>",
    bathTogether: "<1>I think you forgot about me baby.</1>" +
        "<2>Well, if that's what you think, then come on, get in here, cowboy.</2><3/>" +
        "You took a shower together." +
        "<4/><3/><3/>" +
        "<5>Dress up</5>",
    bathTogetherDeny: "<1>{{player}} what do you want? Get away from me, I'm in the shower!</1>" +
        "She didn't really like your idea." +
        "<2>Relationships > {{conditions}}</2><3/>" +
        "<4>Go back</4>",
    checkHerAssFailure: "Before lifting the covers, you stood over <1/> for a while to see if she was asleep. She seemed to be sleeping. " +
        "Then you began to slowly lift the blanket and when you were in the middle, you heard her voice:" +
        "<2>{{player}}, what are you doing?</2>" +
        "<3>I... nothing... Checking if you were covered...</3>" +
        "<2>I'm sleeping, get away from me.</2>" +
        "<3>Okay... I'm sorry.</3>Got to find a more opportune moment for this." +
        "<4>(Actually, no, it's enough to raise relations. Relations > {{relations}})</4><5/><5/>" +
        "<6>Go away</6>",
    checkHerAssSuccess: "Before lifting the covers, you stood over <1/> for a while to see if she was asleep. She seemed to be sleeping. " +
        "Then you began to slowly lift the covers and when you were in the middle, she twitched a little, but continued to sleep.\n" +
        "\"Geez, it's gone.\" - you thought and continued to pull the blanket up.\n" +
        "You've got a great picture:" +
        "<2/><3/><3/>" +
        "<4>Feel her ass (not available in current version)</4><3/>" +
        "<5>Go away</5>",
    handsJob: "<1>Handjob...</1>" +
        "<2/>" +
        "<3>Geez, how disgusting, I won’t touch it with my hands for anything!</3>" +
        "<4>Not available in this version</4><5/><5/>" +
        "<6>Go away</6>",
    blowjob: "<1>Blowjob...</1>" +
        "<2/>" +
        "<3>Don't even ask me for it! Never, you understand???</3>" +
        "<4>Not available in this version</4><5/><5/>" +
        "<6>Go away</6>",
    sexNegative: "<1>Sex...</1>" +
        "<2/>" +
        "<3>{{player}}, get off me, can't you see I'm busy???</3>" +
        "<4>Don't hit on her until you raise the relationship. Relationships > {{relations}}</4><5/><5/>" +
        "<6>Go away</6>",
    sexNo: "<1>Sex...</1>" +
        "<2/>" +
        "<3>{{player}}, I don't want sex, you know? There are times when you just don't want to...</3>" +
        "<4>Raise your relationship with her a little more... Relationships > {{relations}}</4><5/><5/>" +
        "<6>Go away</6>",
    sexYes: "<1>Sex...</1>" +
        "You started slowly kissing <2/> lips, sinking lower and lower, your hands hooked on her jacket and began to slowly pull it off." +
        "<3>Wait, let's please draw the curtains, I'm not comfortable...</3>Said <2/>, stopping you." +
        "<4>Okay, if it makes you feel better.</4>You tried not to show your annoyance at your wife's stupid request.\n" +
        "After the curtains were drawn, you pulled off <2/>'s sweater and continued kissing her gently on the neck." +
        "<5/>" +
        "<4>I can't wait, ready to stick it in right now!</4>You said passionately." +
        "<3>Baby, come on, please, not so fast... I need some time...</3>" +
        "<4>Okay, baby.</4>Hiding your displeasure again, you said and continued to kiss her." +
        "<4>You know how much I love you, right?</4>" +
        "<3>Yes, but let's do it without words, please, you're bringing me down.</3>" +
        "You silently continued to kiss her on the neck, then sank lower, lifted her T-shirt and began to kiss her stomach.\n" +
        "<2/> lay with her eyes closed. Basically, as always. In your couple, you did everything.\n" +
        "After a few moments, you pulled off her T-shirt and continued kissing her." +
        "<6/>" +
        "She still lay there with her eyes closed. The only thing that has changed is her breathing has become faster.\n" +
        "You continued kissing her belly for a while, then her ribs, then lifted her up and pulled off her bra." +
        "<7/>" +
        "A gorgeous view of the breasts of your wife opened up for you. Without wasting a second, you lowered her onto the bed and dug your lips into her tender nipples, massaging her breasts with your hands. " +
        "At the same time, <2/>'s sighs became much more frequent. You felt the tension your dick came into and you could not wait: with one hand you began to take off your pants, with the other, still massaging your wife's breasts.\n" +
        "When your dick was let out, you let her breast go.You take your dick to her pussy as close as you can. She noticed it." +
        "<3>{{player}}, I'm still wearing panties...</3>" +
        "<4>I know, baby, but I'm so excited that I'm ready to fuck you with it on.</4>" +
        "<3>Watch your words, {{player}}! I will not tolerate these filthy words.</3> She said, covering her chest with her hands." +
        "<3>And I need to take off my panties, I don’t want to get them dirty ...</3>" +
        "\"That woman! A real orgasm killer\" - You thought annoyed, but your dick didn't even think to go down, as if telling you " +
        "\"Yeah, it's not very sexy, but I don't give a fuck.\" You pulled off her panties and started caressing her pussy. " +
        "<8/>" +
        "You saw that she was already wriggling from your touches, but she didn't utter a groan or a phrase." +
        "<4>You feel good?</4>" +
        "<3>Yes... Very... You can... penetrate me...</3>" +
        "This is what you needed. Then you finally took off all your clothes and gently put your cock in her. " +
        "To do this, she lay on her back and slightly spread her legs to the side.\n" +
        "<2/> bit her fist in pleasure, but didn't make a sound." +
        "<9/>" +
        "You felt how perfect your cock went. There was a feeling that this pussy was created for it, it was even a little cramped." +
        "But after the first entry, the vagina gradually elaborated, and now you were already making progressive movements towards your wife at full speed." +
        "About five minutes after the start of the action, you decided to change position, so you left your wife and tried to turn her back to you." +
        "<3>Are you... what... are you doing?</3>She asked, breathing heavily." +
        "<4>I want to change position.</4>You answered." +
        "<3>No! I told you I don't like it when my back is up to you, so go ahead without your stuff.</3>" +
        "She said sharply, ceasing to succumb to you and remaining lying on her back. You sighed." +
        "<4>Okay...</4>" +
        "You became irritated again, but tried to hide it. In any case, after a few moments, you inserted your dick into your wife again.\n" +
        "Five minutes later you were ready to cum." +
        "<4>I'm cumming... Hmmm...</4>" +
        "<3>Not in me!</3><2/> yielded and abruptly jumped away from you.\n" +
        "You could no longer hold back, so you cum where you had to." +
        "<10/>" +
        "You cummed on <2/>, then exhaled and wanted to reach out to kiss her, but she was already starting to get up." +
        "<3>Look what a mess you've made here!</3>Said <11/> as she got out of bed." +
        "<3>I'm going to take a shower.</3>You collapsed onto the bed and lay like that for half an hour.\n\n" +
        "<12>Get up and go to shower</12>",
    analSex: "<1>Anal sex...</1>" +
        "<2/>" +
        "<3>Don't even start!!!</3>" +
        "<4>Not available in this version</4><5/><5/>" +
        "<6>Go away</6>"
};

export default wifeEN;